/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryResponse,
  GetApiV1IndividualpaymentParcelsParcelidInvoicesPathParams,
  GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryParams,
  GetApiV1IndividualpaymentParcelsParcelidInvoices401,
  GetApiV1IndividualpaymentParcelsParcelidInvoices500,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentParcelsParcelidInvoices.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentParcelsParcelidInvoices } from "../../clients/individualPaymentParcelsController/getApiV1IndividualpaymentParcelsParcelidInvoices.ts";

export const getApiV1IndividualpaymentParcelsParcelidInvoicesQueryKey = (
  parcelId: GetApiV1IndividualpaymentParcelsParcelidInvoicesPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryParams,
) =>
  [
    {
      url: "/api/v1/individualpayment/parcels/:parcelId/invoices",
      params: { parcelId: parcelId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryKey =
  ReturnType<typeof getApiV1IndividualpaymentParcelsParcelidInvoicesQueryKey>;

export function getApiV1IndividualpaymentParcelsParcelidInvoicesQueryOptions(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidInvoicesPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1IndividualpaymentParcelsParcelidInvoicesQueryKey(
    parcelId,
    params,
  );
  return queryOptions<
    GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelidInvoices401
      | GetApiV1IndividualpaymentParcelsParcelidInvoices500
    >,
    GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryResponse,
    typeof queryKey
  >({
    enabled: !!parcelId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentParcelsParcelidInvoices(
        parcelId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna as NFes da parcela com status, texto do status, última observação registrada e dados de RPS, ordenadas pela data de competência. Migrado do legado IndividualPayment/LoadGridDataAsyncInvoices. **(Requer Authorization para autenticação)**
 * @summary Retorna as notas fiscais (eNotas) de uma parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/invoices}
 */
export function useGetApiV1IndividualpaymentParcelsParcelidInvoices<
  TData = GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryResponse,
  TQueryData = GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryKey,
>(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidInvoicesPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentParcelsParcelidInvoicesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentParcelsParcelidInvoices401
          | GetApiV1IndividualpaymentParcelsParcelidInvoices500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentParcelsParcelidInvoicesQueryKey(parcelId, params);

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentParcelsParcelidInvoicesQueryOptions(
        parcelId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelidInvoices401
      | GetApiV1IndividualpaymentParcelsParcelidInvoices500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
